import { useParams } from 'react-router-dom';
import { useQueryParams } from '@insurancemenu/imenu-components-lib';
import { ProductTemplatePageType } from 'global/checklists-helpers/ProductTemplateChecklistHelper';

interface RFQTemplateProps {
  templateId: string;
  pageType: ProductTemplatePageType;
}

const useRfqTemplate = (): RFQTemplateProps => {
  const { templateId } = useParams<{ templateId: string }>();

  const query = useQueryParams();
  const pageType = (query.get('type') as ProductTemplatePageType) || 'templates';

  return { templateId, pageType };
};

export default useRfqTemplate;
